import { useState } from "react";
import { Building2, User, Lock, AlertCircle } from "lucide-react";
import { sigteApiFetch } from "./sigteUtils";
import logoSigte from "./assets/sigte-logo.png";

// Rediseño Bloque 1: no existe pantalla de login en sigte-prototipo.jsx (el
// "rol" ahi es un <select> cosmetico en el sidebar, sin autenticacion real),
// asi que este layout es nuevo, no portado. Se sigue el lenguaje visual del
// resto del prototipo (tarjetas rounded-2xl, border-neutral-200, bg-white,
// shadow-sm, botones bg-neutral-900) en vez del gradiente azul anterior.
export function SigteLogin(p) {
  var [empresa,setEmpresa]=useState("");
  var [u,setU]=useState("");
  var [pw,setPw]=useState("");
  var [err,setErr]=useState("");
  var [busy,setBusy]=useState(false);

  function go() {
    setErr(""); setBusy(true);
    sigteApiFetch("/login", {method:"POST", body:JSON.stringify({empresa:empresa,username:u,password:pw})})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d.error){setErr(d.error);setBusy(false);}
        else{p.onLogin(Object.assign({}, d.user, {token: d.token, empresa: empresa}));}
      })
      .catch(function(){setErr("Error de conexion. Intenta de nuevo.");setBusy(false);});
  }

  function onEnter(e){ if(e.key==="Enter") go(); }

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 p-4">
      <div className="w-full max-w-sm">
        <div className="mb-7 text-center">
          <img src={logoSigte} alt="SIGTE" className="mx-auto w-48" style={{aspectRatio:"1942/809",height:"auto"}}/>
        </div>
        <div className="rounded-2xl border border-neutral-200 bg-white p-7 shadow-sm">
          <div className="mb-4">
            <label className="mb-1.5 block text-[11px] font-medium uppercase tracking-wide text-neutral-500">Empresa</label>
            <div className="flex items-center gap-2 rounded-lg border border-neutral-200 px-3 py-2 focus-within:border-neutral-400">
              <Building2 size={16} className="shrink-0 text-neutral-400"/>
              <input value={empresa} onChange={function(e){setEmpresa(e.target.value);}} onKeyDown={onEnter}
                placeholder="identificador-de-empresa"
                className="w-full text-sm text-neutral-900 placeholder-neutral-400 outline-none"/>
            </div>
          </div>
          <div className="mb-4">
            <label className="mb-1.5 block text-[11px] font-medium uppercase tracking-wide text-neutral-500">Usuario</label>
            <div className="flex items-center gap-2 rounded-lg border border-neutral-200 px-3 py-2 focus-within:border-neutral-400">
              <User size={16} className="shrink-0 text-neutral-400"/>
              <input value={u} onChange={function(e){setU(e.target.value);}} onKeyDown={onEnter}
                placeholder="Tu usuario"
                className="w-full text-sm text-neutral-900 placeholder-neutral-400 outline-none"/>
            </div>
          </div>
          <div className="mb-5">
            <label className="mb-1.5 block text-[11px] font-medium uppercase tracking-wide text-neutral-500">Contraseña</label>
            <div className="flex items-center gap-2 rounded-lg border border-neutral-200 px-3 py-2 focus-within:border-neutral-400">
              <Lock size={16} className="shrink-0 text-neutral-400"/>
              <input type="password" value={pw} onChange={function(e){setPw(e.target.value);}} onKeyDown={onEnter}
                placeholder="Contraseña"
                className="w-full text-sm text-neutral-900 placeholder-neutral-400 outline-none"/>
            </div>
          </div>
          {err?(
            <div className="mb-4 flex items-center gap-2 rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">
              <AlertCircle size={14} className="shrink-0"/>
              <span>{err}</span>
            </div>
          ):null}
          <button onClick={go} disabled={busy}
            className="w-full rounded-xl bg-neutral-900 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-neutral-700 disabled:opacity-30">
            {busy?"Verificando...":"Iniciar sesión"}
          </button>
        </div>
      </div>
    </div>
  );
}
